<ag1-dropdown-button
  [disabled]="isDisabled()"
  [items]="fileFormats()"
  (clickEvent)="onDownload($event)"
  variant="tertiary"
  [isLoading]="isGenerating()"
  [label]="isGenerating() ? 'Generating File' : 'Download'"
/>
